
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-bde2b1e0&scoped=true!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SelectRetailersComponent.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SelectRetailersComponent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-bde2b1e0!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SelectRetailersComponent.vue"),
  /* scopeId */
  "data-v-bde2b1e0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/DynamicPricingRule/SelectRetailersComponent.vue
// module id = 554
// module chunks = 2